import view from "../../views/landing.js";
import { router } from "../router/index.routes";
import { KTLang } from "../lang/lang";
import { _user, _handler, animateCSS } from "../classes/index.classes";

let landing = {
    render: () => {
        /*const divElement = document.createElement("div");        
        divElement.innerHTML = view;      
        return divElement;*/
        return view;
    },
    after_render: async () => {
        /*$(".btn-sign").off("click");*/
        if(localStorage.getItem("i18nextLng").substring(0,2) == "pt")
        {
            $(".flag-lang").attr("src", "assets/media/flags/br.gif");
        }
        if(localStorage.getItem("i18nextLng").substring(0,2) == "en")
        {
            $(".flag-lang").attr("src", "assets/media/flags/us.gif");
        }
        if(localStorage.getItem("i18nextLng").substring(0,2) == "es")
        {
            $(".flag-lang").attr("src", "assets/media/flags/es.gif");
        }
        if(localStorage.getItem("i18nextLng").substring(0,2) == "zh")
        {
            $(".flag-lang").attr("src", "assets/media/flags/cn.gif");
        }

        $(".btn-continue").off("click");
        //$(".btn-lang").off("click");

        //initialized in the header controller
      /*  $(".btn-sign").on("click",async () => {
            //(await KTAPI).steamLogin();
            window.location = "http://oldapi.pdxplay.org/auth/steam";
        });*/

        $(".btn-continue").on("click",async () => {
            //KTCookie.set("justgo", 1);
            router.navigate("play");
        });

        //$(".btn-lang").on("click", () => {

        //    KTLang.setLang($(this).attr("data-lang"));

        //});
        KTMenu.init();
        KTMenu.init();
        //KTLang.init();
        setTimeout(() => {
            animateBackground();
        }, 10000);
        
    },
    root: true, 
    rerender: true,
    
};

async function animateBackground()
{
    if($(".bg-vid-0").length == 0) return;
    if($(".bg-vid-1").length == 0) return;
    if($(".bg-vid-1").hasClass("d-none"))
    {
        $(".bg-vid-1").removeClass("d-none");
        animateCSS(".bg-vid-1", "fadeIn",'animate__', "3.5s").then(() => {
            setTimeout(() => {
                animateBackground();
            }, 10000);
        });
        animateCSS(".bg-vid-0", "fadeOut",'animate__', "3.5s").then(() => {
            $(".bg-vid-0").addClass("d-none");
        });
    }
    if($(".bg-vid-0").hasClass("d-none"))
    {
        $(".bg-vid-0").removeClass("d-none");
        animateCSS(".bg-vid-0", "fadeIn",'animate__', "3.5s").then(() => {
            setTimeout(() => {
                animateBackground();
            }, 10000);
        });
        animateCSS(".bg-vid-1", "fadeOut",'animate__', "3.5s").then(() => {
            $(".bg-vid-1").addClass("d-none");
        });
    }
}
export default landing;